export type ClientType = 'direct' | 'broker' | 'agent' | 'consignee';

export const CLIENT_TYPES: { value: ClientType; label: string }[] = [
  { value: 'direct', label: 'Direct Client' },
  { value: 'broker', label: 'Broker' },
  { value: 'agent', label: 'Agent' },
  { value: 'consignee', label: 'Consignee' },
];

export interface Client {
  id: number;
  name: string;
  clientType?: string;       // direct, broker, agent, consignee
  defaultCurrency: string;
  defaultMarkupPercentage: number;
  isActive: boolean;
  createdAt: Date;
  updatedAt?: Date;
}

export interface CreateClientDto {
  name: string;
  clientType?: string;
  defaultCurrency: string;
  defaultMarkupPercentage: number;
  isActive: boolean;
}

export interface UpdateClientDto {
  name: string;
  clientType?: string;
  defaultCurrency: string;
  defaultMarkupPercentage: number;
  isActive: boolean;
}
